import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { useDataTableContext } from '../DataTableContext'
import { TableBody, TableBodyProps } from '@mui/material'

function DroppableComponent({ ...props }: TableBodyProps) {
    const { data, onDragDrop } = useDataTableContext()

    const handleDragEnd = (e: any) => {
        if (!e.destination) return
        let tempData = Array.from(data)
        let tempData2 = Array.from(data)
        let [source_data] = tempData2.splice(e.source.index, 1)
        // remove old
        tempData.splice(e.source.index, 1)
        // replace New
        tempData.splice(e.destination.index, 0, source_data)
        onDragDrop && onDragDrop(tempData)
    }

    return (
        <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="crudTable" direction="vertical">
                {(provided) => {
                    return (
                        <TableBody
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            {...props}
                        >
                            {props.children}
                            {provided.placeholder}
                        </TableBody>
                    )
                }}
            </Droppable>
        </DragDropContext>
    )
}
export default DroppableComponent
